import { render, staticRenderFns } from "./SFormProviderComp.vue?vue&type=template&id=819dee46&"
import script from "./SFormProviderComp.vue?vue&type=script&lang=js&"
export * from "./SFormProviderComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports